export const amiProductId = '-1';
// TODO: Change to string once all callers are updated
export const isAmiProduct = (id: number | string) => String(id) === amiProductId;
